/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertasModelDto } from '../../models/alertas-model-dto';

export interface DoctorAlertaControllerObtenerDetalleAlerta$Params {

/**
 * UUID de la alerta a obtener
 */
  uuid: string;
}

export function doctorAlertaControllerObtenerDetalleAlerta(http: HttpClient, rootUrl: string, params: DoctorAlertaControllerObtenerDetalleAlerta$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertasModelDto>> {
  const rb = new RequestBuilder(rootUrl, doctorAlertaControllerObtenerDetalleAlerta.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlertasModelDto>;
    })
  );
}

doctorAlertaControllerObtenerDetalleAlerta.PATH = '/api/doctor-alertas/detalle-alerta/{uuid}';
